import { InvestigacionDTO } from "@DTOS";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { Actualizador } from "./Actualizador";
import { AccionEnum } from "@shared/enums";
import { GruposFiltrosService } from "src/app/layout/investigaciones/gruposFiltros.service";

export class GrupoFiltroActualizador extends Actualizador {
    constructor(private grupoFiltroService: GruposFiltrosService) {
        super();
    }

    public async actualizar(
        investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion
    ): Promise<InvestigacionDTO> {
        const investigacionClon = investigacion.clon();
        const grupoFiltro = datos.datosGrupoFiltro!.grupoFiltro;
        const grupo = investigacionClon.grupos.find(x => x.id === grupoFiltro.grupo.id);
        if (datos.datosGrupoFiltro!.accion === AccionEnum.AGREGAR) {
            const grupoFiltroDTO =
                await this.grupoFiltroService.agregarGrupoFiltro(grupoFiltro);
            grupo?.gruposFiltros.push(grupoFiltroDTO);
        } else if (datos.datosGrupoFiltro!.accion === AccionEnum.ACTUALIZAR) {
            const grupoFiltroDTO =
                await this.grupoFiltroService.guardarGrupoFiltro(grupoFiltro);
            grupo!.gruposFiltros = grupo!.gruposFiltros
                .map(x => x.id !== grupoFiltro.id ? grupoFiltroDTO : x);
        } else if (datos.datosGrupoFiltro!.accion === AccionEnum.BORRAR) {
            if (grupoFiltro.id == null || grupoFiltro.id === 0) {
                return investigacionClon;
            }
            await this.grupoFiltroService.eliminarGrupoFiltro(grupoFiltro);
            grupo!.gruposFiltros = grupo!.gruposFiltros.filter(x => x.id !== grupoFiltro.id);
        }
        return investigacionClon;
    }

    public esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.datosGrupoFiltro != null;
    }

}
